import React from "react";
import RegionNeighborhoodView from "../../components/RegionNeighborhoodView";

import styles from "./styles.module.css";
import './index.css';
import { canUseDOM } from "../../helpers/utils";
import { pushToDataLayer } from "../../helpers/gtm";

export default props => {
  if (!props.subtitle) {
    return null;
  }
  return (
    <RegionNeighborhoodView>
      <wrapper
        className={styles.wrapper}
        tabIndex={0}
        onKeyDown={e => {
          if (e && e.stopPropagation) {
            e.stopPropagation();
          }
          if (e.keyCode !== 13) {
            return null;
          }
          return props.onClick && props.onClick();
        }}
        onClick={() => {
          if (canUseDOM) {
            pushToDataLayer({
              event: 'Region - Map Selection',
              eventTitle: 'Map_Pin',
              eventText: props.subtitle
            })
          }
          props.onClick && props.onClick()
        }}
      >
        <image />
        <title />
        <subtitle className={styles.subtitle}>{props.subtitle}</subtitle>
      </wrapper>
    </RegionNeighborhoodView>
  );
};
